import { analytics, performance } from "../../../firebase.ts";
import { trace, PerformanceTrace } from "firebase/performance";
import { logEvent } from "firebase/analytics";
import { Loader } from "@googlemaps/js-api-loader";
import { getToken } from "firebase/app-check";
//temp import { appCheck } from "../../../firebase.ts";
import { Quotas } from "../../../managers/Quotas.ts";

import { Temple, Temples } from "../../../managers/Temples.ts";
import { Buddhists } from "../../../managers/Buddhists.ts";
import { Readers } from "../../../managers/Readers.ts";
import { Reader } from "../../../models/Reader.ts";
import { Timestamp } from "firebase/firestore";
import {
    numberToKhmerWords,
    getRandomNumber,
    getRandomNumber2
} from "../../../models/Number.ts";

import { Feedbacks } from "../../../managers/Feedbacks.ts";
import { HeartBank } from "../../../managers/HeartBank.ts";
import { SwHeader } from "../../sw-header/sw-header.ts";
import { SwFooter } from "../../sw-footer/sw-footer.ts";

import template from "./sw-map.mjs";
import Strings from "../../../models/Strings.json";
import {
    LANGUAGE,
    isApple,
    isSafari,
    getIP,
    getLocation,
    html,
    isProduction,
    MAP
    //deviceType
} from "../../global.ts";

import BUDDHA from "../../../public/default.png";
import SW from "../../../public/siliconwat.png"; // svg, jpg need ts declaration
const strings: any = Strings;

interface FormattedLocation {
    place_id: string;
    formatted_address: string;
    lat: number;
    lng: number;
    //TODO: store: address_components and others??
}

interface FormattedPlace {
    id: string;
    displayName: string;
    formattedAddress: string;
    lat: number;
    lng: number;
    photo?: string;
}

export class SwMap extends HTMLElement {
    private heartbank = new HeartBank();
    private temples = new Temples();
    private buddhists = new Buddhists();
    private readers = new Readers();
    private feedbacks = new Feedbacks();
    private quotas = new Quotas();
    private componentTrace: PerformanceTrace;
    private header = document.querySelector("sw-header") as SwHeader;
    private footer = document.querySelector("sw-footer") as SwFooter;

    private container: HTMLElement;
    private view: HTMLElement;
    private statsBtn: HTMLButtonElement; // B floating button
    private mapSearch: HTMLButtonElement;
    private mapSound: HTMLButtonElement;
    private templesAdd: HTMLButtonElement;
    private homesAdd: HTMLButtonElement;
    private templesBtn: HTMLButtonElement;
    private monksBtn: HTMLButtonElement;
    private homesBtn: HTMLButtonElement;
    private readersBtn: HTMLButtonElement;

    private thanks: HTMLSpanElement;
    private students: HTMLSpanElement; // readers
    private homes: HTMLSpanElement; // readers
    private monks: HTMLSpanElement; // readers
    private wats: HTMLSpanElement; // temples
    private hours: HTMLSpanElement; // not used
    private pages: HTMLSpanElement; // deprecated
    private tips: HTMLSpanElement; // not used

    private loader: Loader | null = null;
    private map: google.maps.Map | null = null;
    private location: google.maps.LatLngLiteral | null = null;
    private bounds: any; //google.maps.LatLngBounds

    private infoWindow: google.maps.InfoWindow | null = null;
    private marker: google.maps.marker.AdvancedMarkerElement | null = null; // user reader
    private templeMarkers: google.maps.marker.AdvancedMarkerElement[] = [];
    private monkMarkers: google.maps.marker.AdvancedMarkerElement[] = [];
    private homeMarkers: google.maps.marker.AdvancedMarkerElement[] = [];
    private readerMarkers: google.maps.marker.AdvancedMarkerElement[] = [];

    private watchId: number | null = null;
    private isGranted = false; // one time per reload
    private isPrompted = false; // one time per reload
    private isPrompted2 = false; // one time per reload

    private page: "leaderboard" | "now" | "history" = MAP;
    private showReaders = true;
    private showHomes = true;
    private showMonks = true;
    private showTemples = true;
    private isInfoWindowOpen = false;
    private isFullMap = false;

    private size = 50; // random readers
    private userSize = 2.0;
    private readerSize = 1.0;
    private homeSize = 1.0;
    private monkSize = 1.5;
    private templeSize = 1.5;

    private addressMiles = 5; // miles to cache
    private addressCache = new Map<string, FormattedLocation>();
    // TODO: later: store addresses in firestore to save money ??

    private maxTemples = 30; // same cost for any amount: double check this
    private templeMiles = 5; // miles to cache
    private templeCache = new Map<string, FormattedPlace[]>(); //google.maps.places.Place[]
    private templeSearchDebounceTimeout: number | null = null;
    private debouncedFindTemples: () => void;

    private readonly phnomPenh = { lat: 11.5564, lng: 104.9282 };
    private readonly longBeach = { lat: 33.7701, lng: -118.1937 }; // { lat: 33.77005, lng: -118.193741 }
    private readonly USA = { lat: 39.8283, lng: -98.5795 }; // continental center

    // Cambodia's approximate bounding box
    private readonly cambodiaBounds = {
        minLat: 10.4, // Southern extent
        maxLat: 14.7, // Northern extent
        minLng: 102.3, // Western extent
        maxLng: 107.6 // Eastern extent
    };

    private readonly cambodiaBounds2 = {
        // Original values were: min: 10.4, max: 14.7
        minLat: 9.5, // Extended south into the Gulf of Thailand & Southern Vietnam
        maxLat: 15.5, // Extended north into Thailand and Laos

        // Original values were: min: 102.3, max: 107.6
        minLng: 102.3, // Extended west into Thailand
        maxLng: 108.5 // Extended east to include Vietnam's Mekong Delta
    };

    private readonly cambodiaBounds3 = {
        minLat: 9.0,
        maxLat: 16.0,
        minLng: 101.0,
        maxLng: 109.0
    };

    // California's approximate bounding box
    private readonly californiaBounds = {
        minLat: 32.5, // Southern extent
        maxLat: 42.0, // Northern extent
        minLng: -124.4, // Western extent
        maxLng: -114.1 // Eastern extent
    };

    // continentalUSBounds
    private readonly californiaBounds2 = {
        minLat: 24.5, // Southern extent: Key West, FL (~24.5° N) & southern tip of Texas
        maxLat: 49.5, // Northern extent: Northwest Angle, MN (~49.4° N)
        minLng: -125.0, // Western extent: Cape Alava, WA (~124.7° W)
        maxLng: -66.9 // Eastern extent: West Quoddy Head, ME (~66.9° W)
    };

    private readonly franceBounds = {
        minLat: 41.3, // Southernmost point of Corsica
        maxLat: 51.1, // Northernmost point of mainland France
        minLng: -5.2, // Westernmost point of mainland France
        maxLng: 9.6 // Easternmost point of Corsica
    };

    private readonly franceBounds2 = {
        minLat: 41.0,
        maxLat: 51.5,
        minLng: -6.0,
        maxLng: 10.0
    };

    private readonly australiaBounds = {
        minLat: -38.0, // Moves north, cutting off the southern tip of Victoria
        maxLat: -12.0, // Moves south, cutting off the tip of Cape York
        minLng: 113.5, // Moves east, shaving off Steep Point
        maxLng: 153.0 // Moves west, trimming the eastern bulge
    };

    private readonly australiaBounds2 = {
        minLat: -39.2, // Southernmost point: South Point, Victoria
        maxLat: -10.6, // Northernmost point: Cape York, Queensland
        minLng: 112.9, // Westernmost point: Steep Point, WA
        maxLng: 153.7 // Easternmost point: Cape Byron, NSW
    };

    private readonly australiaBounds3 = {
        minLat: -44.0, // Southernmost point of Tasmania
        maxLat: -9.0, // Northernmost tip of Cape York
        minLng: 112.0, // Westernmost point of the mainland
        maxLng: 154.0 // Easternmost point (Cape Byron)
    };

    constructor() {
        super();
        this.componentTrace = trace(performance, "component");
        this.componentTrace.putAttribute("view", "sw-map");
        this.componentTrace.start();
        this.appendChild(template.content.cloneNode(true));

        this.container = this.querySelector("#sw-map")!;
        this.view = this.querySelector("#sw-map-view")!;
        this.statsBtn = this.querySelector("#sw-map-stats")!;
        this.mapSearch = this.querySelector("#sw-map-search")!;
        this.mapSound = this.querySelector("#sw-map-sound")!;
        this.templesAdd = this.querySelector("#sw-map-temples-add")!;
        this.homesAdd = this.querySelector("#sw-map-homes-add")!;
        this.templesBtn = this.querySelector("#sw-map-temples-toggle")!;
        this.monksBtn = this.querySelector("#sw-map-monks-toggle")!;
        this.homesBtn = this.querySelector("#sw-map-homes-toggle")!;
        this.readersBtn = this.querySelector("#sw-map-readers-toggle")!;

        this.thanks = this.querySelector("#sw-map-thanks")!;
        this.students = this.querySelector("#sw-map-readers")!;
        this.homes = this.querySelector("#sw-map-homes")!;
        this.monks = this.querySelector("#sw-map-monks")!;
        this.wats = this.querySelector("#sw-map-temples")!;
        this.hours = this.querySelector("#sw-map-hours")!;
        this.pages = this.querySelector("#sw-map-pages")!;
        this.tips = this.querySelector("#sw-map-tips")!;

        this.debouncedFindTemples = this.debounceTemples(() => {
            if (!this.isInfoWindowOpen && this.isAdminTemples()) {
                this.findAndDisplayTemples();
            }
        }, 1000); // 750ms delay is a good starting point

        window.removeReader = async (id: string) => {
            if (this.isAdminReaders() && confirm(strings.map35b[LANGUAGE])) {
                await this.buddhists.remove(id);
                this.show(this.page);
                this.heartbank.alertAdmin("map/reader/remove/", id);
            }
        };

        window.publishTemple = async (id: string) => {
            if (this.isAdminTemples() && confirm(strings.map49[LANGUAGE])) {
                await this.temples.updateStatus(id, true);
                await this.renderTemples();
                this.heartbank.alertAdmin("map/temple/edit/status/active");
            }
        };

        window.unpublishTemple = async (id: string) => {
            if (this.isAdminTemples() && confirm(strings.map50[LANGUAGE])) {
                await this.temples.updateStatus(id, false);
                await this.renderTemples();
                this.heartbank.alertAdmin("map/temple/edit/status/inactive");
            }
        };

        // not used bc reloading user info window is too complex right now
        window.addTemple = async (
            latitude: number,
            longitude: number,
            address: string
        ) => {
            if (this.isAdminTemples()) {
                const coordinate = prompt(
                    strings.map59[LANGUAGE],
                    strings.map60[LANGUAGE]
                );
                if (coordinate !== null) {
                    if (
                        coordinate === "" ||
                        coordinate === strings.map60[LANGUAGE]
                    ) {
                        // current location
                    } else {
                        const position = coordinate.split(",");
                        latitude = parseFloat(position[0]);
                        longitude = parseFloat(position[1]);
                    }
                    const name = prompt(strings.map52[LANGUAGE]);
                    if (name) {
                        await this.temples.adminAdd(
                            name,
                            latitude,
                            longitude,
                            address
                        );
                        await this.show(this.page); // needed bc counter has changed
                        //this.map?.panTo({ lat: latitude, lng: longitude });
                        this.heartbank.alertAdmin(
                            `map/user/add/temple/${name}: `,
                            address
                        );
                    }
                }
            }
        };

        window.removeTemple = async (id: string, pid: string) => {
            if (this.isAdminTemples() && confirm(strings.map51[LANGUAGE])) {
                await this.temples.remove(id, pid);
                await this.renderTemples();
                this.heartbank.alertAdmin(`map/temple/remove/${id}/`, pid);
            }
        };

        window.editTempleName = async (id: string, name: string) => {
            if (this.isAdminTemples()) {
                const newName = prompt(strings.map46[LANGUAGE], name);
                if (newName) {
                    const temple = await this.temples.updateName(id, newName);
                    await this.addTemple(temple, true);
                    this.heartbank.alertAdmin(
                        `map/temple/edit/name: ${name} => ${newName}`
                    );
                }
            }
        };

        window.editTempleAddress = async (id: string, address: string) => {
            if (this.isAdminTemples()) {
                const newAddress = prompt(strings.map47[LANGUAGE], address);
                if (newAddress) {
                    const temple = await this.temples.updateAddress(
                        id,
                        newAddress
                    );
                    await this.addTemple(temple, true);
                    this.heartbank.alertAdmin(
                        `map/temple/edit/address: ${address} => ${newAddress}`
                    );
                }
            }
        };

        window.editTempleLink = async (id: string, link: string) => {
            if (this.isAdminTemples()) {
                const newLink = prompt(strings.map48[LANGUAGE], link);
                if (newLink) {
                    const temple = await this.temples.updateLink(id, newLink);
                    await this.addTemple(temple, true);
                    this.heartbank.alertAdmin(
                        `map/temple/edit/link: ${link} => ${newLink}`
                    );
                }
            }
        };

        window.editTemplePhoto = async (id: string) => {
            if (this.isAdminTemples()) {
                const temple = await this.temples.updatePhoto(
                    id,
                    (progress) => {
                        console.info("Upload is " + progress + "% done");
                        // or: sw-banner // can't use bc fullscreen mode hides it
                        // this.dispatchEvent(
                        //     new CustomEvent<{ info: string }>("sw-alert", {
                        //         bubbles: true,
                        //         detail: {
                        //             info: strings.map36[LANGUAGE]
                        //         }
                        //     })
                        // );
                    }
                );
                if (temple) {
                    await this.addTemple(temple, true);
                    this.heartbank.alertAdmin(
                        "map/temple/edit/photo: ",
                        temple.photo
                    );
                } // else alert();
            }
        };
    }

    private debounceTemples(func: () => void, delay: number) {
        return () => {
            if (this.templeSearchDebounceTimeout) {
                clearTimeout(this.templeSearchDebounceTimeout);
            }
            this.templeSearchDebounceTimeout = window.setTimeout(func, delay);
        };
    }

    // also mobile biz
    private isAdminReaders() {
        return (
            this.page === "history" &&
            !this.isFullMap &&
            this.heartbank.isAdmin()
        );
    }

    // also home biz
    private isAdminHomes() {
        return (
            this.page === "history" &&
            this.isFullMap &&
            this.heartbank.isAdmin()
        );
    }

    private isAdminMonks() {
        return (
            this.page === "leaderboard" &&
            !this.isFullMap &&
            this.heartbank.isAdmin()
        );
    }

    private isAdminTemples() {
        return (
            this.page === "leaderboard" &&
            this.isFullMap &&
            this.heartbank.isAdmin()
        );
    }

    connectedCallback() {
        this.readers.stop();
        this.renderTotalThanks();
        //this.getCurrentLocation();

        this.mapSearch.addEventListener("click", () => {
            if (!this.heartbank.isAdmin()) alert(strings.soon[LANGUAGE]);
            this.panToHome();
        });

        this.mapSound.addEventListener("click", () => {
            alert(strings.soon[LANGUAGE]);
        });

        this.templesAdd.addEventListener("click", async () => {
            if (this.isAdminTemples()) {
                const coordinate = prompt(
                    strings.map59[LANGUAGE],
                    strings.map60[LANGUAGE]
                );
                if (coordinate !== null) {
                    let latitude = this.location?.lat;
                    let longitude = this.location?.lng;

                    if (
                        coordinate === "" ||
                        coordinate === strings.map60[LANGUAGE]
                    ) {
                        // current location
                    } else {
                        const position = coordinate.split(",");
                        latitude = parseFloat(position[0] || "0");
                        longitude = parseFloat(position[1] || "0");
                    }

                    if (latitude && longitude) {
                        const name = prompt(strings.map52[LANGUAGE]);
                        if (name) {
                            await this.temples.adminAdd(
                                name,
                                latitude,
                                longitude
                            );
                            await this.show(this.page); // needed bc counter has changed
                            this.map?.panTo({ lat: latitude, lng: longitude });
                            this.heartbank.alertAdmin(
                                `map/user/add/temple/${name}: `,
                                `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${latitude},${longitude}`
                            );
                        }
                    } else alert(strings.map54[LANGUAGE]);
                }
            }
        });

        this.homesAdd.addEventListener("click", () => {
            alert(strings.soon[LANGUAGE]);
        });

        this.statsBtn.addEventListener("click", async () => {
            if (this.isFullMap) {
                this.header.show();
                this.footer.show();
                this.view.classList.add("hidden");
                this.statsBtn.classList.remove("ring-4");
                this.isFullMap = false;
            } else {
                this.header.hide();
                this.footer.hide();
                this.view.classList.remove("hidden");
                this.statsBtn.classList.add("ring-4");
                this.isFullMap = true;
            }
            this.mapSound.classList.toggle(
                "hidden",
                this.isAdminTemples() || this.isAdminHomes()
            );
            this.templesAdd.classList.toggle("hidden", !this.isAdminTemples());
            this.homesAdd.classList.toggle("hidden", !this.isAdminHomes());
            this.renderTemples();
        });

        this.templesBtn.addEventListener("click", () => {
            if (this.showTemples) {
                this.templesBtn.style.opacity = "0.5";
                this.showTemples = false;
            } else {
                this.templesBtn.style.opacity = "";
                this.showTemples = true;
            }
            this.renderTemples();
        });

        this.monksBtn.addEventListener("click", () => {
            if (this.showMonks) {
                this.monksBtn.style.opacity = "0.5";
                this.showMonks = false;
            } else {
                this.monksBtn.style.opacity = "";
                this.showMonks = true;
            }
        });

        this.homesBtn.addEventListener("click", () => {
            if (this.showHomes) {
                this.homesBtn.style.opacity = "0.5";
                this.showHomes = false;
            } else {
                this.homesBtn.style.opacity = "";
                this.showHomes = true;
            }
        });

        this.readersBtn.addEventListener("click", () => {
            if (this.showReaders) {
                this.readersBtn.style.opacity = "0.5";
                this.showReaders = false;
            } else {
                this.readersBtn.style.opacity = "";
                this.showReaders = true;
            }
            this.renderReaderMarkers();
        });

        // this.heartbank.addAuthStateListener3((hero) => {
        //     if (window.location.hash === "#readership") this.show(this.page);
        // });

        this.addListeners();
        this.componentTrace.incrementMetric("count", 1);
        this.componentTrace.stop();
    }

    private renderReaderMarkers() {
        if (this.showReaders)
            this.readerMarkers.forEach((marker) => (marker.map = this.map));
        else this.readerMarkers.forEach((marker) => (marker.map = null));
    }

    private async initMap() {
        // Initialize Google Maps Loader
        this.loader = new Loader({
            apiKey: "AIzaSyBK85eUHtSPtDwlBmf3mB_6Y_E1J1X8xA4",
            version: "weekly",
            libraries: ["maps", "marker", "places", "geometry"],
            language: strings.language[LANGUAGE], // 👈 this makes results and labels appear in Khmer
            region: strings.region[LANGUAGE] // 👈 optional, helps with regional context (Cambodia)
        });

        try {
            // Load the required libraries
            const [libraries] = await Promise.all([
                this.loader.importLibrary("core"),
                this.loader.importLibrary("maps"),
                this.loader.importLibrary("marker"),
                this.loader.importLibrary("places"),
                this.loader.importLibrary("geometry")
            ]);

            // https://developers.google.com/maps/documentation/javascript/maps-app-check
            // const settings = google.maps.Settings.getInstance() as any;

            //temp
            // settings.fetchAppCheckToken = () =>
            //     getToken(appCheck, /* forceRefresh = */ false);

            // Initialize the map after libraries are loaded
            await this.renderMap();
        } catch (error) {
            //console.error("Failed to load Google Maps: ", error.message);
            if (navigator.onLine) alert(strings.map4[LANGUAGE]);
        }
    }

    private async renderMap(color: "light" | "dark" | "system" | null = null) {
        if (!(await this.quotas.isFree("dynamicmaps"))) {
            alert(strings.map37[LANGUAGE]);
            return;
        }

        const scheme = color || localStorage.getItem("colorScheme");
        let colorScheme;
        switch (scheme) {
            case "light":
                colorScheme = google.maps.ColorScheme.LIGHT;
                break;
            case "dark":
                colorScheme = google.maps.ColorScheme.DARK;
                break;
            case "system":
                colorScheme = google.maps.ColorScheme.FOLLOW_SYSTEM;
                break;
        }

        const ip = await getIP();
        const location: any = await getLocation(ip);
        const coordinate =
            location.latitude && location.longitude
                ? { lat: location.latitude, lng: location.longitude }
                : null;
        if (!this.location) this.location = coordinate || this.longBeach;

        // Initialize map with user's location
        this.map = new google.maps.Map(this.container, {
            center: this.location,
            zoom: 1.5, // shows at the beginning
            mapId: "9311f726d06a3b44", // Custom map ID
            colorScheme,
            // --- Set Default Map Type to Terrain ---
            mapTypeId: google.maps.MapTypeId.TERRAIN,
            // --- Enable Tilt (45 degrees) ---
            tilt: 45,

            // Enable the controls you want to position
            //scaleControl: false, // doesn't exist
            zoomControl: false,
            fullscreenControl: false,
            disableDefaultUI: true,
            mapTypeControl: true,
            streetViewControl: true,

            // --- Configure Control Positions ---
            zoomControlOptions: {
                position: google.maps.ControlPosition.RIGHT_TOP
            },
            mapTypeControlOptions: {
                //style: google.maps.MapTypeControlStyle.HORIZONTAL_BAR, // Optional: change style
                position: google.maps.ControlPosition.TOP_CENTER
            },
            streetViewControlOptions: {
                position: google.maps.ControlPosition.BOTTOM_CENTER
            },
            fullscreenControlOptions: {
                position: google.maps.ControlPosition.BOTTOM_LEFT
            }
        });

        // // Add listener to search for temples when the map view is idle
        // this.map.addListener("idle", () => {
        //     //console.log(this.map!.getZoom());
        //     if (this.showTemples && !this.isInfoWindowOpen)
        //         this.findAndDisplayTemples();
        // });
        this.map.addListener("idle", this.debouncedFindTemples);

        // Add a listener for map clicks
        this.map.addListener("click", this.handleMapClick.bind(this));

        this.infoWindow = new google.maps.InfoWindow();
        this.infoWindow.addListener("closeclick", () => {
            this.isInfoWindowOpen = false;
            this.readers.isRealTime = true;
        });

        // Listen for the 'domready' event to fire when the InfoWindow is ready.
        // google.maps.event.addListener(this.infoWindow, "domready", () => {
        //     const mode = document.documentElement.classList.contains("dark")
        //         ? "dark"
        //         : "light";
        //     const iwBackgroundColor = mode === "dark" ? "#2c3e50" : "white";

        //     // 1. Target the main content container
        //     const iwOuter =
        //         document.querySelector<HTMLElement>(".gm-style-iw-c");
        //     if (iwOuter) {
        //         iwOuter.style.backgroundColor = iwBackgroundColor; // A dark blue
        //         //iwOuter.style.padding = "0"; // Remove default padding if needed
        //     }

        //     // 2. Target the content div to change text color
        //     const iwContent =
        //         document.querySelector<HTMLElement>(".gm-style-iw-d");
        //     if (iwContent) {
        //         iwContent.style.color = "#ecf0f1"; // A light grey/white
        //     }

        //     // 3. Target the close button
        //     const closeButton = document.querySelector<HTMLElement>(
        //         ".gm-ui-hover-effect"
        //     );
        //     if (closeButton) {
        //         // SVG close buttons are tricky. Let's change its color via filter.
        //         // For a simple background change: closeButton.style.backgroundColor = 'red';
        //         (closeButton.firstElementChild as HTMLElement).style.filter =
        //             mode === "dark" ? "invert(1)" : "";
        //     }

        //     // // 4. Target the arrow "tip" // doesn't work
        //     // // The tip is made of two divs, one for the outer border and one for the inner fill.
        //     // const iwTipOuter = document.querySelector<HTMLElement>(
        //     //     ".gm-style-iw-t > div > div:last-child"
        //     // );
        //     // if (iwTipOuter) {
        //     //     iwTipOuter.style.backgroundColor = iwBackgroundColor;
        //     // }
        //     // const iwTipInner = document.querySelector<HTMLElement>(
        //     //     ".gm-style-iw-t > div > div:first-child"
        //     // );
        //     // if (iwTipInner) {
        //     //     iwTipInner.style.boxShadow = "none"; // Optional: remove the default shadow
        //     // }
        // });
    }

    private async addListeners() {
        // this.heartbank.addAuthStateListener3(() => {
        //     if (this.heartbank.isAdmin()) {
        //         this.pages.classList.add(
        //             "border-b",
        //             "border-gray-200",
        //             "dark:border-gray-600"
        //         );
        //         this.thanks.classList.replace("hidden", "flex");
        //         this.tips.classList.replace("hidden", "flex");
        //     } else {
        //         this.pages.classList.remove(
        //             "border-b",
        //             "border-gray-200",
        //             "dark:border-gray-600"
        //         );
        //         this.thanks.classList.replace("flex", "hidden");
        //         this.tips.classList.replace("flex", "hidden");
        //     }
        // });

        //TODO: listen for tailwind html tag color scheme change instead ??
        document.body.addEventListener(
            "sw-color-scheme",
            async (event: Event) => {
                const customEvent = event as CustomEvent<{
                    colorScheme: string;
                }>;
                const colorScheme = customEvent.detail.colorScheme as
                    | "light"
                    | "dark"
                    | "system";
                if (this.loader) {
                    await this.renderMap(colorScheme);
                    await this.render();
                    this.getCurrentLocation(); // needed for markers to show
                }
            }
        );
    }

    async show(page: "leaderboard" | "now" | "history" = MAP) {
        this.page = page;
        this.classList.remove("hidden");
        const B = this.statsBtn.firstElementChild as SVGElement;

        if (page === "now") {
            B.classList.add("animate-heartbeat");
            this.readers.now(async (readers: Reader[], changes: Reader[]) => {
                //console.log(readers, changes);
                if (readers.length > 0) {
                    if (!this.loader) await this.initMap();
                    await this.render(readers);
                    this.getCurrentLocation(); // needed for markers to show
                }
            });
        } else {
            B.classList.remove("animate-heartbeat");
            if (!this.loader) await this.initMap();
            await this.render();
            this.getCurrentLocation(); // needed for markers to show
        }
    }

    hide() {
        this.readers.stop();
        this.classList.add("hidden");
    }

    //// render

    private async render(readers: Reader[] = []) {
        // reset
        this.readerMarkers.forEach((marker) => {
            marker.map = null;
            //google.maps.event.clearInstanceListeners(marker); // weird bug
        });
        this.readerMarkers = [];
        this.bounds = new google.maps.LatLngBounds();

        // dummy
        if (this.page !== "now") {
            await this.renderReaders();
            //TODO: render other dummies here too
        }

        switch (this.page) {
            case "leaderboard":
                const readers2 = await this.readers.leaderboard();
                await this.renderReader(this.getRank(readers2));
                await this.renderLeaderboard(readers2);
                this.renderTotalReaders(await this.buddhists.count());
                //this.renderTotalReaders(getRandomNumber2(100, 1000));
                this.renderPages(readers, true);
                break;
            case "now":
                await this.renderReader(this.getRank(readers), true);
                await this.renderNow(readers);
                this.renderTotalReaders();
                this.renderPages(readers);
                break;
            case "history":
                const readers3 = await this.readers.history();
                await this.renderReader(this.getRank(readers3));
                await this.renderHistory(readers3);
                this.renderTotalReaders(await this.buddhists.count());
                //this.renderTotalReaders(getRandomNumber2(100, 1000));
                this.renderPages(readers, true);
                break;
        }

        // order is important for pin sizes overlap
        await this.renderTemples(); //if (this.templeMarkers.length === 0)
        this.renderReaderMarkers();
        if (this.page === "now") {
            this.panToHome();
        } else if (!this.bounds.isEmpty()) {
            // Only fit bounds if there are markers to show
            this.map!.fitBounds(this.bounds); // Adjust map to fit all markers
            this.map!.panToBounds(this.bounds, 50); // Optional: Add padding (in pixels) to ensure markers aren't at the edge
        }
    }

    private getRank(readers: Reader[]) {
        const reader = readers.find(
            (reader) => reader.id === this.heartbank.getDeviceID()
        );
        return reader?.rank || 0;
    }

    private async renderTotalThanks() {
        const total = await this.feedbacks.count();
        this.thanks.textContent = numberToKhmerWords(total, LANGUAGE);
    }

    private async renderTotalReaders(count: number = 0) {
        const total = count + (await this.readers.count());
        this.students.textContent = numberToKhmerWords(total, LANGUAGE);
    }

    private renderTotalHomes() {}

    private renderTotalMonks() {}

    private async renderTotalTemples(count: number | null = null) {
        const total = count || (await this.temples.count());
        this.wats.textContent = numberToKhmerWords(total, LANGUAGE);
    }

    //TODO: v2 use real time database to get all
    private renderPages(readers: Reader[], isDummy: boolean = false) {
        const total = readers.reduce(
            (sum, reader: Reader) => sum + (reader.pages ?? 0),
            0
        );
        this.pages.textContent = isDummy
            ? getRandomNumber(1000, 10000, LANGUAGE)
            : numberToKhmerWords(total, LANGUAGE);
    }

    private async renderNow(readers: Reader[]) {
        for (const reader of readers) {
            this.extendBounds(reader);
            await this.addReader(reader, this.readerSize);
        }
    }

    private async renderLeaderboard(readers: Reader[]) {
        for (const reader of readers) {
            if (!this.heartbank.isAdmin()) this.extendBounds(reader);
            await this.addReader(reader, this.readerSize);
        }
    }

    private async renderHistory(readers: Reader[]) {
        for (const reader of readers) {
            if (!this.heartbank.isAdmin()) this.extendBounds(reader);
            await this.addReader(reader, this.readerSize);
        }
    }

    private async renderReaders() {
        const readers = await this.buddhists.get();
        const total = await this.readers.count();
        for (const reader of readers) {
            reader.rank = total + reader.rank!;
            await this.addReader(reader, this.readerSize);
        }
    }

    /**
     * Handles a click event on the map. It performs a reverse geocode lookup
     * for the clicked coordinates and dispatches a 'sw-map-click' custom event
     * with the location details.
     * @param event The Google Maps mouse event from the click.
     */
    private async handleMapClick(event: google.maps.MapMouseEvent) {
        if (
            !(
                this.isAdminReaders() ||
                this.isAdminHomes() ||
                this.isAdminMonks() ||
                this.isAdminTemples()
            )
        )
            return;

        if (!event.latLng) {
            console.warn("Map click event did not have LatLng information.");
            return;
        }

        const position = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng()
        };
        const location = await this.geocode(position);

        if (location) {
            const pin = new google.maps.marker.PinElement({
                background: "skyblue",
                borderColor: "blue",
                glyph: "⏳", // deprecated in newer api version: TODO: in v2
                glyphColor: "white",
                scale: this.userSize
            });
            const marker = new google.maps.marker.AdvancedMarkerElement({
                position,
                map: null,
                content: pin.element,
                title: strings.map36[LANGUAGE]
            });

            if (this.isAdminReaders()) {
                //marker.map = this.map;
                //this.readerMarkers.push(marker);
                await this.buddhists.add(
                    location.lat,
                    location.lng,
                    location.formatted_address
                );
                marker.map = this.map;
                this.readerMarkers.push(marker);
                this.renderTotalReaders(await this.buddhists.count());
                //await this.show(this.page);
                //this.map?.panTo(location);
                this.heartbank.alertAdmin(
                    "map/reader/add/",
                    location.formatted_address
                );
            }

            if (this.isAdminHomes()) {
            }

            if (this.isAdminMonks()) {
            }

            if (this.isAdminTemples()) {
                const name = prompt(strings.map52[LANGUAGE]);
                if (name) {
                    marker.map = this.map;
                    this.templeMarkers.push(marker);
                    await this.temples.adminAdd(
                        name,
                        location.lat,
                        location.lng,
                        location.formatted_address
                    );
                    await this.show(this.page); // needed to show real marker
                    this.map?.panTo(location);
                    this.heartbank.alertAdmin(
                        `map/temple/add/${name}: `,
                        location.formatted_address
                    );
                }
            }
        } else alert(strings.map37[LANGUAGE]); // alert admin quota has exceeded

        // let address: string | null = null;
        // try {
        //     const geocoder = new google.maps.Geocoder();
        //     const request: google.maps.GeocoderRequest = {
        //         location: clickedLatLng,
        //         language: strings.language[LANGUAGE]
        //     };
        //     const response = await geocoder.geocode(request);

        //     if (response.results && response.results.length > 0) {
        //         address = response.results[0].formatted_address;
        //         await this.buddhists.add(
        //             clickedLatLng.lat,
        //             clickedLatLng.lng,
        //             address
        //         );
        //         this.show(this.page);
        //         this.heartbank.alertAdmin("map/reader/add/", address);
        //     } else {
        //         console.warn(
        //             "Reverse geocoding failed: No results found for the clicked location.",
        //             clickedLatLng
        //         );
        //     }
        // } catch (error) {
        //     console.error("Reverse geocoding API call failed:", error);
        // } finally {
        //     // Dispatch the event regardless of geocoding success
        //     const mapClickEvent = new CustomEvent("sw-map-click", {
        //         detail: {
        //             coordinate: clickedLatLng,
        //             formatted_address: address
        //         },
        //         bubbles: true, // Allows the event to bubble up through the DOM
        //         composed: true // Allows the event to cross shadow DOM boundaries
        //     });
        //     this.dispatchEvent(mapClickEvent);
        // }
    }

    private getAnonReader(id: string) {
        return {
            id,
            uid: "",
            user: "HeartBank®",
            address: strings.map17[LANGUAGE],
            latitude:
                LANGUAGE === "khmer" ? this.phnomPenh.lat : this.longBeach.lat,
            longitude:
                LANGUAGE === "khmer" ? this.phnomPenh.lng : this.longBeach.lng,
            lastActive: Timestamp.now(),
            pages: 0,
            rank: 0
        } as Reader;
    }

    // user: render and add
    private async renderReader(rank: number, extendBounds: boolean = false) {
        const id = this.heartbank.getDeviceID();
        const reader = ((await this.readers.get(id)) ||
            this.getAnonReader(id)) as Reader;
        const user = await this.readers.getUser(
            this.heartbank.user?.uid || reader.uid || ""
        );

        const name = user.displayName || user.email || strings.map20[LANGUAGE];
        //const mapURL = `https://www.google.com/maps/search/?api=1&query=${reader.latitude},${reader.longitude}`;
        const mapURL = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${
            this.location?.lat ?? reader.latitude
        },${this.location?.lng ?? reader.longitude}`;
        //const mapURL = `https://www.google.com/maps?layer=c&cbll=${reader.latitude},${reader.longitude}&cbp=12,0,0,0,0`;

        // TODO: later: show hb aura, username, etc
        const content = html`<div
            class="max-w-[300] text-black dark:text-white pb-3">
            <aside
                class="absolute top-2 font-black text-xl text-purple-600 dark:text-purple-500">
                ${strings.map27[LANGUAGE]}
                <span class="text-teal-300">
                    ${numberToKhmerWords(rank, LANGUAGE)}
                </span>
            </aside>
            <p class="font-bold text-2xl">
                <span
                    class="hidden w-3 h-3 me-1 ${this.getStatus(
                        reader.lastActive?.toDate() || new Date()
                    )} rounded-full"></span>
                ${name}
            </p>
            <br />
            <div class="inline-flex rounded-md shadow-xs" role="group">
                <button
                    title="${strings.map6[LANGUAGE]}"
                    onclick="heartbank.alertAdmin('map/profile/click/333');alert('${strings
                        .soon[LANGUAGE]}')"
                    type="button"
                    class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                    <svg
                        class="w-5 h-5 me-0"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="gold"
                        viewBox="0 0 576 512">
                        <path
                            d="M64 64C28.7 64 0 92.7 0 128L0 336c0 35.3 28.7 64 64 64l.4 0c4 44.9 41.7 80 87.6 80s83.6-35.1 87.6-80l104.7 0c4 44.9 41.7 80 87.6 80 46.1 0 83.9-35.4 87.7-80.5 31.7-3.8 56.3-30.8 56.3-63.5l0-101.3c0-13.8-4.5-27.3-12.8-38.4l-80-106.7C471.1 73.5 452.1 64 432 64L64 64zM504 224l-120 0 0-96 48 0 72 96zM64 224l0-96 96 0 0 96-96 0zm160 0l0-96 96 0 0 96-96 0zM392 392a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM152 352a40 40 0 1 1 0 80 40 40 0 1 1 0-80z" />
                    </svg>
                </button>
                <button
                    title="${strings.map5[LANGUAGE]}"
                    onclick="vault('login')"
                    type="button"
                    class="${this.heartbank.user
                        ? "hidden"
                        : "rounded-e-lg"} inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border-r border-t border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                    <svg
                        class="w-5 h-5 me-0"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="orange"
                        viewBox="0 0 512 512">
                        <path
                            d="M345 273c9.4-9.4 9.4-24.6 0-33.9L201 95c-6.9-6.9-17.2-8.9-26.2-5.2S160 102.3 160 112l0 80-112 0c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l112 0 0 80c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2L345 273zm7 143c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c53 0 96-43 96-96l0-256c0-53-43-96-96-96l-64 0c-17.7 0-32 14.3-32 32s14.3 32 32 32l64 0c17.7 0 32 14.3 32 32l0 256c0 17.7-14.3 32-32 32l-64 0z" />
                    </svg>
                </button>
                <button
                    title="${strings.feedback5[LANGUAGE]}"
                    onclick="vault('logout')"
                    type="button"
                    class="${this.heartbank.user
                        ? ""
                        : "hidden"} inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border-t border-r border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                    <svg
                        class="w-5 h-5 me-0"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="red"
                        viewBox="0 0 512 512">
                        <path
                            d="M505 273c9.4-9.4 9.4-24.6 0-33.9L361 95c-6.9-6.9-17.2-8.9-26.2-5.2S320 102.3 320 112l0 80-112 0c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l112 0 0 80c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2L505 273zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z" />
                    </svg>
                </button>
                <button
                    title="${strings.map22[LANGUAGE]}"
                    onclick="vault('humanity')"
                    type="button"
                    class="${this.heartbank.user
                        ? ""
                        : "hidden"} inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border-t border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                    <svg
                        class="w-5 h-5 me-0"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="teal"
                        viewBox="0 0 512 512">
                        <path
                            d="M195.1 9.5C198.1-5.3 211.2-16 226.4-16l59.8 0c15.2 0 28.3 10.7 31.3 25.5L332 79.5c14.1 6 27.3 13.7 39.3 22.8l67.8-22.5c14.4-4.8 30.2 1.2 37.8 14.4l29.9 51.8c7.6 13.2 4.9 29.8-6.5 39.9L447 233.3c.9 7.4 1.3 15 1.3 22.7s-.5 15.3-1.3 22.7l53.4 47.5c11.4 10.1 14 26.8 6.5 39.9l-29.9 51.8c-7.6 13.1-23.4 19.2-37.8 14.4l-67.8-22.5c-12.1 9.1-25.3 16.7-39.3 22.8l-14.4 69.9c-3.1 14.9-16.2 25.5-31.3 25.5l-59.8 0c-15.2 0-28.3-10.7-31.3-25.5l-14.4-69.9c-14.1-6-27.2-13.7-39.3-22.8L73.5 432.3c-14.4 4.8-30.2-1.2-37.8-14.4L5.8 366.1c-7.6-13.2-4.9-29.8 6.5-39.9l53.4-47.5c-.9-7.4-1.3-15-1.3-22.7s.5-15.3 1.3-22.7L12.3 185.8c-11.4-10.1-14-26.8-6.5-39.9L35.7 94.1c7.6-13.2 23.4-19.2 37.8-14.4l67.8 22.5c12.1-9.1 25.3-16.7 39.3-22.8L195.1 9.5zM256.3 336a80 80 0 1 0 -.6-160 80 80 0 1 0 .6 160z" />
                    </svg>
                </button>
                <button
                    title="${strings.map23[LANGUAGE]}"
                    onclick="vault('passkeys')"
                    type="button"
                    class="${this.heartbank.user
                        ? ""
                        : "hidden"} inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                    <svg
                        class="w-5 h-5 me-0"
                        aria-hidden="true"
                        xmlns="http://www.w3.org/2000/svg"
                        fill="green"
                        viewBox="0 0 512 512">
                        <path
                            d="M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0 160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24l0-40 40 0c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z" />
                    </svg>
                </button>
            </div>
            <br />
            <br />
            <p class="text-base">
                ${strings.map8[LANGUAGE]}
                <strong class="font-black text-orange-400">
                    ${getRandomNumber(100, 1000, LANGUAGE)}
                </strong>
                ${strings.map8b[LANGUAGE]}
            </p>
            <p class="text-base">
                ${strings.map14[LANGUAGE]}
                <strong class="font-black text-orange-400">
                    ${numberToKhmerWords(reader.pages || 0, LANGUAGE)}
                </strong>
                ${strings.map14b[LANGUAGE]}
            </p>
            <p class="text-base">
                ${strings.map18[LANGUAGE]}
                <strong class="font-black text-orange-400">
                    ${getRandomNumber(50, 100, LANGUAGE)}
                </strong>
                ${strings.map18b[LANGUAGE]}
            </p>
            <br />
            <br />
            <img
                onclick="heartbank.alertAdmin('map/profile/click/avatar');
                alert('${strings.soon[LANGUAGE]}')"
                src="${user.photoURL || BUDDHA}"
                alt="${name}"
                class="w-3/4 object-cover rounded-full" />
            <br />
            <button
                onclick="heartbank.alertAdmin('map/profile/click/reward');prompt('${strings
                    .map28b[LANGUAGE]}','${strings.soon[LANGUAGE]}')">
                <svg
                    class="inline-flex w-7 h-7 me-1 text-green-600 dark:text-green-500"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    fill="currentColor">
                    <path
                        d="M328 112l-144 0-37.3-74.5c-1.8-3.6-2.7-7.6-2.7-11.6 0-14.3 11.6-25.9 25.9-25.9L342.1 0c14.3 0 25.9 11.6 25.9 25.9 0 4-.9 8-2.7 11.6L328 112zM169.6 160l172.8 0 48.7 40.6C457.6 256 496 338 496 424.5 496 472.8 456.8 512 408.5 512l-305.1 0C55.2 512 16 472.8 16 424.5 16 338 54.4 256 120.9 200.6L169.6 160zM260 224c-11 0-20 9-20 20l0 4c-28.8 .3-52 23.7-52 52.5 0 25.7 18.5 47.6 43.9 51.8l41.7 7c6 1 10.4 6.2 10.4 12.3 0 6.9-5.6 12.5-12.5 12.5L216 384c-11 0-20 9-20 20s9 20 20 20l24 0 0 4c0 11 9 20 20 20s20-9 20-20l0-4.7c25-4.1 44-25.7 44-51.8 0-25.7-18.5-47.6-43.9-51.8l-41.7-7c-6-1-10.4-6.2-10.4-12.3 0-6.9 5.6-12.5 12.5-12.5l47.5 0c11 0 20-9 20-20s-9-20-20-20l-8 0 0-4c0-11-9-20-20-20z" />
                </svg>
                <span
                    class="font-black text-sm text-green-600 dark:text-green-500">
                    ${strings.map28[LANGUAGE]}
                </span>
            </button>
            <br />
            <br />
            <button
                onclick="heartbank.alertAdmin('map/profile/click/sponsor');prompt('${strings
                    .map32b[LANGUAGE]}','${strings.soon[LANGUAGE]}')">
                <svg
                    class="inline-flex w-7 h-7 me-1 text-pink-500 dark:text-pink-500"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    fill="currentColor">
                    <path
                        d="M288-16c-13.3 0-24 10.7-24 24l0 12-1.8 0c-36.6 0-66.2 29.7-66.2 66.2 0 33.4 24.9 61.6 58 65.7l61 7.6c5.1 .6 9 5 9 10.2 0 5.7-4.6 10.2-10.2 10.2L240 180c-15.5 0-28 12.5-28 28s12.5 28 28 28l24 0 0 12c0 13.3 10.7 24 24 24s24-10.7 24-24l0-12 1.8 0c36.6 0 66.2-29.7 66.2-66.2 0-33.4-24.9-61.6-58-65.7l-61-7.6c-5.1-.6-9-5-9-10.2 0-5.7 4.6-10.2 10.2-10.2L328 76c15.5 0 28-12.5 28-28s-12.5-28-28-28l-16 0 0-12c0-13.3-10.7-24-24-24zM109.3 341.5L66.7 384 32 384c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l320.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416 280 416c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-152.2 0c-33.9 0-66.5 13.5-90.5 37.5z" />
                </svg>
                <span
                    class="font-black text-sm text-pink-600 dark:text-pink-500">
                    ${strings.map32[LANGUAGE]}
                </span>
            </button>
            <br />
            <br />
            <button
                onclick="heartbank.alertAdmin('map/profile/click/thank');alert('${strings
                    .soon[LANGUAGE]}')">
                <svg
                    class="inline-flex w-7 h-7 me-1"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="orangered">
                    <path
                        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                        transform="rotate(45 12 12)" />
                </svg>
                <span class="font-black text-sm text-[orangered]">
                    ${strings.map31[LANGUAGE]}
                </span>
            </button>
            <br />
            <br />
            <br />
            <a
                title="${strings.map45[LANGUAGE]}"
                href="${mapURL}"
                target="_blank"
                onclick="heartbank.alertAdmin('map/click/user/${name}: ${mapURL}')">
                <p class="font-bold text-sm">
                    ${reader.lastActive?.toDate().formatDate()}
                </p>
                <br />
                <p class="block text-sm underline text-blue-600">
                    ${reader.address}
                </p>
                <br />
                <p class="italic text-xs">${reader.user}</p>
            </a>
            <!--<button
                onclick="window.addTemple(${this.location?.lat ??
            reader.latitude}, ${this.location?.lng ??
            reader.longitude}, '${reader.address}')"
                class="${this.isAdminTemples()
                ? ""
                : "hidden"} text-2xl mt-5 text-green-500">
                ☸️ ${strings.map53[LANGUAGE]}
            </button>-->
        </div>`;

        if (this.marker) {
            this.marker.position = this.location;
            this.marker.title = `${name} | ${reader.address}`;
            this.infoWindow!.setContent(content);
        } else {
            const pin = new google.maps.marker.PinElement({
                background: "#8B008B", // purple
                borderColor: "#4B0082",
                glyph: "❤",
                glyphColor: "white",
                scale: this.userSize
            });

            this.marker = new google.maps.marker.AdvancedMarkerElement({
                position: this.location,
                map: this.map,
                content: pin.element,
                title: `${name} | ${reader.address}`
            });

            this.marker.addListener("gmp-click", () => {
                this.zoom();
                //this.bounds.extend(marker.position);

                this.isInfoWindowOpen = true;
                this.infoWindow!.setContent(content);
                this.infoWindow!.open(this.map, this.marker);

                this.readers.isRealTime = false;
                this.heartbank.alertAdmin(
                    `map/click/user/${name}: `,
                    reader.address
                );
            });
        }

        if (extendBounds) this.bounds.extend(this.location);
    }

    private async addReader(reader: Reader, scale: number) {
        const user = await this.readers.getUser(reader.uid);

        // Create info window
        // https://developers.google.com/maps/documentation/javascript/infowindows
        // const infoWindow = new google.maps.InfoWindow({
        //     content: `<div class="min-w-[200]"><p class="font-bold text-lg">${
        //         strings.map7[LANGUAGE]
        //     } ${reader}</p><p class="text-base">${getRandomNumber(50, 100)} ${
        //         strings.map14[LANGUAGE]
        //     }</p></div>`
        // });

        // const infoWindow = new google.maps.InfoWindow({
        //     content: `<div class="min-w-[200]">
        //         <p class="font-bold text-lg underline">
        //             ${
        //                 user.displayName ||
        //                 strings.map7[LANGUAGE] + " #" + reader.rank
        //             }
        //         </p>
        //         <br>
        //         <p class="text-base">
        //             <strong class="font-black">
        //                 ${reader.pages}
        //             </strong> ${strings.map14[LANGUAGE]}
        //         </p>
        //         <br>
        //         <p class="font-bold text-sm">
        //             ${reader.lastActive?.toDate().formatDate()}
        //         </p>
        //         <br>
        //         <p class="text-sm">
        //             ${reader.address}
        //         </p>
        //         <br>
        //         <p class="italic text-xs">
        //             ${reader.user}
        //         </p>
        //     </div>`
        // });

        const name = user.displayName || strings.map7[LANGUAGE];
        //const mapURL = `https://www.google.com/maps/search/?api=1&query=${reader.latitude},${reader.longitude}`; //(${encodeURIComponent(reader.user)})
        const mapURL = `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${reader.latitude},${reader.longitude}`;

        // TODO: later: show hb aura, username, etc
        const content = html`<div
            class="max-w-[300] text-black dark:text-white pb-3">
            <aside
                class="absolute top-2 font-black text-xl text-purple-600 dark:text-purple-500">
                ${strings.map27[LANGUAGE]}
                <span class="text-teal-300">
                    ${numberToKhmerWords(reader.rank || 0, LANGUAGE)}
                </span>
            </aside>
            <p class="font-bold text-2xl">
                <span
                    class="inline-flex w-3 h-3 me-1 ${this.getStatus(
                        reader.lastActive?.toDate() || new Date()
                    )} rounded-full"></span>
                ${name}
            </p>
            <br />
            <p class="text-base">
                ${strings.map8[LANGUAGE]}
                <strong class="font-black text-orange-400">
                    ${getRandomNumber(100, 1000, LANGUAGE)}
                </strong>
                ${strings.map8b[LANGUAGE]}
            </p>
            <p class="text-base">
                ${strings.map14[LANGUAGE]}
                <strong class="font-black text-orange-400">
                    ${numberToKhmerWords(reader.pages || 0, LANGUAGE)}
                </strong>
                ${strings.map14b[LANGUAGE]}
            </p>
            <p class="text-base">
                ${strings.map18[LANGUAGE]}
                <strong class="font-black text-orange-400">
                    ${getRandomNumber(50, 100, LANGUAGE)}
                </strong>
                ${strings.map18b[LANGUAGE]}
            </p>
            <br />
            <br />
            <img
                onclick="heartbank.alertAdmin('map/reader/click/avatar');alert('${strings
                    .soon[LANGUAGE]}')"
                src="${user.photoURL || this.getRandomAvatarUrl()}"
                alt="${name}"
                class="w-3/4 object-cover rounded-full" />
            <br />
            <button
                onclick="heartbank.alertAdmin('map/reader/click/reward');alert('${strings
                    .soon[LANGUAGE]}')">
                <svg
                    class="inline-flex w-7 h-7 me-2 text-green-600 dark:text-green-500"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    fill="currentColor">
                    <path
                        d="M328 112l-144 0-37.3-74.5c-1.8-3.6-2.7-7.6-2.7-11.6 0-14.3 11.6-25.9 25.9-25.9L342.1 0c14.3 0 25.9 11.6 25.9 25.9 0 4-.9 8-2.7 11.6L328 112zM169.6 160l172.8 0 48.7 40.6C457.6 256 496 338 496 424.5 496 472.8 456.8 512 408.5 512l-305.1 0C55.2 512 16 472.8 16 424.5 16 338 54.4 256 120.9 200.6L169.6 160zM260 224c-11 0-20 9-20 20l0 4c-28.8 .3-52 23.7-52 52.5 0 25.7 18.5 47.6 43.9 51.8l41.7 7c6 1 10.4 6.2 10.4 12.3 0 6.9-5.6 12.5-12.5 12.5L216 384c-11 0-20 9-20 20s9 20 20 20l24 0 0 4c0 11 9 20 20 20s20-9 20-20l0-4.7c25-4.1 44-25.7 44-51.8 0-25.7-18.5-47.6-43.9-51.8l-41.7-7c-6-1-10.4-6.2-10.4-12.3 0-6.9 5.6-12.5 12.5-12.5l47.5 0c11 0 20-9 20-20s-9-20-20-20l-8 0 0-4c0-11-9-20-20-20z" />
                </svg>
                <span
                    class="font-black text-lg text-green-600 dark:text-green-500">
                    ${strings.map29[LANGUAGE]}
                </span>
            </button>
            <br />
            <br />
            <button
                onclick="heartbank.alertAdmin('map/reader/click/sponsor');prompt('${strings
                    .map33b[LANGUAGE]}','${strings.soon[LANGUAGE]}')">
                <svg
                    class="inline-flex w-7 h-7 me-2 text-pink-500 dark:text-pink-500"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 576 512"
                    fill="currentColor">
                    <path
                        d="M288-16c-13.3 0-24 10.7-24 24l0 12-1.8 0c-36.6 0-66.2 29.7-66.2 66.2 0 33.4 24.9 61.6 58 65.7l61 7.6c5.1 .6 9 5 9 10.2 0 5.7-4.6 10.2-10.2 10.2L240 180c-15.5 0-28 12.5-28 28s12.5 28 28 28l24 0 0 12c0 13.3 10.7 24 24 24s24-10.7 24-24l0-12 1.8 0c36.6 0 66.2-29.7 66.2-66.2 0-33.4-24.9-61.6-58-65.7l-61-7.6c-5.1-.6-9-5-9-10.2 0-5.7 4.6-10.2 10.2-10.2L328 76c15.5 0 28-12.5 28-28s-12.5-28-28-28l-16 0 0-12c0-13.3-10.7-24-24-24zM109.3 341.5L66.7 384 32 384c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l320.5 0c29 0 57.3-9.3 80.7-26.5l126.6-93.3c17.8-13.1 21.6-38.1 8.5-55.9s-38.1-21.6-55.9-8.5L392.6 416 280 416c-13.3 0-24-10.7-24-24s10.7-24 24-24l72 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-152.2 0c-33.9 0-66.5 13.5-90.5 37.5z" />
                </svg>
                <span
                    class="font-black text-lg text-pink-600 dark:text-pink-500">
                    ${strings.map33[LANGUAGE]}
                </span>
            </button>
            <br />
            <br />
            <button
                onclick="heartbank.alertAdmin('map/reader/click/thank');alert('${strings
                    .soon[LANGUAGE]}')">
                <svg
                    class="inline-flex w-7 h-7 me-2"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    fill="orangered">
                    <path
                        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                        transform="rotate(45 12 12)" />
                </svg>
                <span class="font-black text-lg text-[orangered]">
                    ${strings.map26[LANGUAGE]}
                </span>
            </button>
            <br />
            <br />
            <br />
            <a
                title="${strings.map45[LANGUAGE]}"
                href="${mapURL}"
                target="_blank"
                onclick="heartbank.alertAdmin('map/click/reader/${name}: ${mapURL}')">
                <p class="font-bold text-sm">
                    ${reader.lastActive?.toDate().formatDate()}
                </p>
                <br />
                <p class="text-sm underline text-blue-600">${reader.address}</p>
            </a>
            <br />
            ${reader.user === "HeartBank®" && this.isAdminReaders()
                ? html`<button
                      onclick="window.removeReader('${reader.id}')"
                      class="text-2xl mt-5 text-red-600">
                      🗑️ ${strings.map35[LANGUAGE]}
                  </button>`
                : html`<p class="italic text-xs">${reader.user}</p>`}
        </div>`; // bug: remove button is also shown in fullscreen bc need reload

        const pin = new google.maps.marker.PinElement({
            // background: '#FFA500', // Hex code for orange
            background: reader.id ? "dodgerblue" : "dodgerblue", // Can often use color names
            borderColor: "blue", // A darker orange/brown for border (optional)
            glyph: "☻",
            glyphColor: "white", // Color for any internal glyph (if used, none here)
            scale // Adjust size (1.0 is default)
        });

        const position: google.maps.LatLngLiteral = {
            lat: reader.latitude,
            lng: reader.longitude
        };

        // Create Advanced Marker
        const marker = new google.maps.marker.AdvancedMarkerElement({
            position,
            map: null,
            content: pin.element,
            title: `${name} | ${reader.address}` //strings.map7[LANGUAGE] + " " + reader
        });

        // Add click listener to marker
        marker.addListener("gmp-click", () => {
            this.zoom();
            //this.bounds.extend(marker.position);

            this.isInfoWindowOpen = true;
            this.infoWindow!.setContent(content);
            this.infoWindow!.open(this.map, marker);
            //infoWindow!.open(this.map, marker);

            //this.animateToMarker(position);

            // const markerBounds = new google.maps.LatLngBounds();
            // // Create bounds around the marker (0.1 degrees ~ 11km)
            // markerBounds.extend({
            //     lat: position.lat - 1.5,
            //     lng: position.lng - 1.5
            // });
            // markerBounds.extend({
            //     lat: position.lat + 1.5,
            //     lng: position.lng + 1.5
            // });

            // this.map!.fitBounds(markerBounds); // Smoothly pans and zooms

            this.readers.isRealTime = false;
            this.heartbank.alertAdmin(
                `map/click/reader/${name}: `,
                reader.address
            );
        });

        this.readerMarkers.push(marker);
    }

    private getStatus(date: Date): string {
        const now = Date.now();
        const diffMs = now - date.getTime();
        const oneHour = 60 * 60 * 1000;
        const oneDay = 24 * oneHour;
        const oneWeek = 7 * oneDay;
        const oneMonth = 4 * oneWeek;

        if (diffMs <= oneDay) {
            return "bg-green-500";
        } else if (diffMs <= oneWeek) {
            return "bg-yellow-300";
        } else if (diffMs <= oneMonth) {
            return "bg-orange-300";
        } else {
            return "bg-red-600";
        }
    }

    private getRandomAvatarUrl(): string {
        return `https://raw.githubusercontent.com/SiliconWat/avatar.siliconwat.dev/main/id/AV${getRandomNumber2(
            1,
            120
        )}.png`;
    }

    // deprecated bc too slow bc of service worker cache; also pro no cdn
    private getRandomAvatarUrl2(): string {
        const base = "https://avatar.iran.liara.run/public";
        const cacheBuster = `?t=${Math.random().toString(36).slice(2)}`;
        return `${base}${cacheBuster}`;
    }

    private getPhoto(base: string): string {
        const cacheBuster = `&t=${Math.random().toString(36).slice(2)}`;
        return `${base}${cacheBuster}`;
    }

    // temples

    public async findAndDisplayTemples(reload = false) {
        if (!this.map || !google.maps.places) return;

        // --- Start of Changes ---
        const center = this.map.getCenter();
        const bounds = this.map.getBounds();

        // Guard against calling the API with an undefined center or bounds
        if (!center || !bounds) {
            console.warn(
                "Map center or bounds not available yet. Skipping temple search."
            );
            return;
        }
        // --- End of Changes ---
        //console.log(center.lat(), center.lng());

        // +++ ADD CACHING LOGIC +++
        // Create a unique key for the current map view
        //const cacheKey = bounds.toUrlValue(6); // 6 decimal places of precision

        // --- START OF NEW GRID CACHING LOGIC ---

        // 1. Define the size of our grid cell in degrees. (1 miles)
        const gridSizeDegrees = 0.0144 * this.templeMiles; // 10 miles

        // 2. "Snap" the map's center coordinates to our grid.
        const gridLat =
            Math.round(center.lat() / gridSizeDegrees) * gridSizeDegrees;
        const gridLng =
            Math.round(center.lng() / gridSizeDegrees) * gridSizeDegrees;

        // 3. Create a stable cache key based on the grid cell, not the exact bounds.
        // We round to a few decimal places to avoid floating point inaccuracies.
        const cacheKey = `grid_${gridLat.toFixed(4)}_${gridLng.toFixed(4)}`;

        if (this.templeCache.has(cacheKey)) {
            console.log("Using cached temple data...");
            if (reload)
                await this.renderTemples2(this.templeCache.get(cacheKey)!);
            return; // Exit the function, no API call needed
        }
        // +++ END CACHING LOGIC +++

        // need to be after cache
        if (await this.quotas.isFree("places2"))
            await this.queryPlaces2(cacheKey, center, bounds);
        else if (await this.quotas.isFree("places1"))
            await this.queryPlaces1(cacheKey, bounds);
        else await this.renderTemples2();
    }

    /**
     * Searches for Buddhist temples using the new Places API and displays them as markers.
     */
    private async queryPlaces2(
        cacheKey: string,
        center: google.maps.LatLng,
        bounds: google.maps.LatLngBounds
    ) {
        // CORRECTED: Use searchText for text queries.
        const request: google.maps.places.SearchByTextRequest = {
            fields: [
                "id", // Basic Data
                "displayName", // Basic Data
                "location", // Basic Data (part of geometry)
                "formattedAddress" // Basic Data
                //"photos" // Atmosphere Data <-- most expensive
            ],
            textQuery: strings.map15[LANGUAGE], // This is the primary parameter for searchText
            // Use locationBias to prefer results in the current map view
            locationBias: {
                center: this.getNormalizedCenter(center),
                radius: this.calculateMapRadius(bounds)
            },
            maxResultCount: this.maxTemples,
            language: strings.language[LANGUAGE]
        };

        try {
            // CORRECTED: Call the searchText method instead of searchNearby
            const { places } = await google.maps.places.Place.searchByText(
                request
            );

            const places2: FormattedPlace[] = places.map(
                (place): FormattedPlace => ({
                    id: place.id,
                    displayName: place.displayName ?? "",
                    formattedAddress: place.formattedAddress ?? "",
                    lat: place.location?.lat() ?? 0,
                    lng: place.location?.lng() ?? 0
                    // photo:
                    //     place.photos && place.photos.length > 0
                    //         ? place.photos[0].getURI({ maxWidth: 400 })
                    //         : ""
                })
            );

            // +++ STORE RESULTS IN CACHE +++
            this.templeCache.set(cacheKey, places2);

            if (places2.length) {
                this.renderTemples2(places2);
            } else {
                console.log("No temples found in the current map view.");
            }
        } catch (error) {
            console.error("Places v2 search failed: ", error);
        }
    }

    /**
     * Searches for Buddhist temples within the current map view and displays them as markers.
     * This method can be triggered by a UI button or an event listener.
     */
    private async queryPlaces1(
        cacheKey: string,
        bounds: google.maps.LatLngBounds
    ) {
        const service = new google.maps.places.PlacesService(this.map!);
        const request: google.maps.places.PlaceSearchRequest = {
            bounds,
            keyword: strings.map15[LANGUAGE]
        };

        try {
            service.nearbySearch(request, (results, status) => {
                if (
                    status === google.maps.places.PlacesServiceStatus.OK &&
                    results
                ) {
                    // Convert old Places API results to our new custom Place style objects
                    const places: FormattedPlace[] = results.map(
                        (place): FormattedPlace => ({
                            id: place.place_id ?? "",
                            displayName: place.name ?? "",
                            formattedAddress:
                                place.formatted_address ??
                                place.plus_code?.compound_code ??
                                "",
                            lat: place.geometry?.location?.lat() ?? 0,
                            lng: place.geometry?.location?.lng() ?? 0
                            // photo:
                            //     place.photos && place.photos.length > 0
                            //         ? place.photos[0].getUrl({ maxWidth: 400 })
                            //         : "" // url available but not permitted until another api call to get details
                        })
                    );
                    //console.log(results);
                    this.templeCache.set(cacheKey, places);
                    this.renderTemples2(places);
                } else if (
                    status ===
                    google.maps.places.PlacesServiceStatus.ZERO_RESULTS
                ) {
                    console.log("No temples found in the current map view.");
                } else {
                    console.error("Places search failed with status: ", status);
                }
            });
        } catch (error) {
            console.error("Places v1 search failed: ", error);
        }
    }

    private async renderTemples() {
        // Clear previous temple markers to avoid duplicates
        this.hideTempleMarkers();
        this.templeMarkers = [];

        if (this.showTemples) {
            if (this.isAdminTemples()) this.findAndDisplayTemples(true);
            else {
                const temples = await this.temples.get("active");
                temples.forEach((temple) => this.addTemple(temple));
                this.renderTotalTemples(temples.length);
            }
        }
    }

    // for admin
    private async renderTemples2(places: FormattedPlace[] = []) {
        // Clear previous temple markers to avoid duplicates
        this.hideTempleMarkers();
        this.templeMarkers = [];
        //places.forEach((place) => this.addTemple(place));

        for (const place of places) {
            if (!(await this.temples.exists(place.id)))
                this.temples.add(
                    place.id,
                    place.displayName,
                    place.lat,
                    place.lng,
                    place.formattedAddress
                );
        }

        const temples = await this.temples.get();
        temples.forEach((temple) => this.addTemple(temple));
    }

    /**
     * Creates a single marker on the map for a given place.
     * @param place The Google Place object for the temple.
     */
    private addTemple(temple: Temple, reload = false) {
        if (!this.map) return;
        // const infoWindow = new google.maps.InfoWindow({
        //     content: `<div>
        //         <p class="font-bold text-lg">
        //             ${place.displayName}
        //         </p>
        //         ${photoHtml}
        //         <br>
        //         <p class="text-sm">
        //             ${place.formattedAddress}
        //         </p>
        //     </div>`
        // });

        // const mapURL =
        //     deviceType === "Mobile"
        //         ? `https://www.google.com/maps/search/?api=1&query_place_id=${
        //               place.id
        //           }&query=${place.location.lat()},${place.location.lng()}(${encodeURIComponent(
        //               place.displayName!
        //           )})`
        //         : `https://www.google.com/maps/place/?q=place_id:${place.id}`;

        // const mapURL = `https://www.google.com/maps/search/?api=1&query_place_id=${
        //     place.id
        // }&query=${place.location.lat()},${place.location.lng()}`;
        const photo =
            reload && temple.photo
                ? this.getPhoto(temple.photo)
                : temple.photo || SW;
        const mapURL =
            temple.link ||
            `https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${temple.latitude},${temple.longitude}`;

        const content = this.isAdminTemples()
            ? html`<div class="max-w-[300] text-black dark:text-white pb-3">
                  <button
                      title="${strings.map48b[LANGUAGE]}"
                      onclick="window.editTempleLink('${temple.id}', '${mapURL}')"
                      class="absolute top-2 font-black text-xl text-purple-600 dark:text-purple-500">
                      ${strings.map27[LANGUAGE]}
                      <span class="text-teal-300">
                          ${getRandomNumber(1, 100, LANGUAGE)}
                      </span>
                      <span>✏️</span>
                  </button>
                  <button
                      title="${strings.map46b[LANGUAGE]}"
                      class="font-bold text-2xl"
                      onclick="window.editTempleName('${temple.id}', '${temple.name}')">
                      ${temple.name}
                      <span>✏️</span>
                  </button>
                  <br />
                  <br />
                  <div class="inline-flex rounded-md shadow-xs" role="group">
                      <button
                          title="${strings.map6[LANGUAGE]}"
                          onclick="heartbank.alertAdmin('map/temple/click/333');alert('${strings
                              .soon[LANGUAGE]}')"
                          type="button"
                          class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                          <svg
                              class="w-5 h-5 me-0"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="gold"
                              viewBox="0 0 576 512">
                              <path
                                  d="M64 64C28.7 64 0 92.7 0 128L0 336c0 35.3 28.7 64 64 64l.4 0c4 44.9 41.7 80 87.6 80s83.6-35.1 87.6-80l104.7 0c4 44.9 41.7 80 87.6 80 46.1 0 83.9-35.4 87.7-80.5 31.7-3.8 56.3-30.8 56.3-63.5l0-101.3c0-13.8-4.5-27.3-12.8-38.4l-80-106.7C471.1 73.5 452.1 64 432 64L64 64zM504 224l-120 0 0-96 48 0 72 96zM64 224l0-96 96 0 0 96-96 0zm160 0l0-96 96 0 0 96-96 0zM392 392a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM152 352a40 40 0 1 1 0 80 40 40 0 1 1 0-80z" />
                          </svg>
                      </button>
                      <button
                          title="${strings.map24[LANGUAGE]}"
                          onclick="heartbank.alertAdmin('map/temple/click/checkin');alert('${strings
                              .soon[LANGUAGE]}')"
                          type="button"
                          class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border-t border-r border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                          <svg
                              class="w-5 h-5 me-0"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="blueviolet"
                              viewBox="0 0 512 512">
                              <path
                                  d="M256 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 160l64 0c35.3 0 64 28.7 64 64l0 48c0 17.7-14.3 32-32 32l-1.8 0-11.1 99.5c-1.8 16.2-15.5 28.5-31.8 28.5l-38.7 0c-16.3 0-30-12.3-31.8-28.5l-11.1-99.5-1.8 0c-17.7 0-32-14.3-32-32l0-48c0-35.3 28.7-64 64-64zM412.4 400.2c-16.1-4.2-34.8-7.6-55.4-10.2l5.3-47.7c22.7 2.9 43.7 6.7 62.1 11.5 22.4 5.8 42.6 13.3 57.8 23.3 14.7 9.6 29.8 24.9 29.8 47s-15.1 37.4-29.8 47c-15.2 9.9-35.5 17.5-57.8 23.3-45.1 11.7-105.3 17.8-168.4 17.8s-123.3-6.1-168.4-17.8C65.2 488.4 45 480.9 29.8 471 15.1 461.4 0 446.1 0 424s15.1-37.4 29.8-47c15.2-9.9 35.5-17.5 57.8-23.3 18.5-4.8 39.5-8.6 62.1-11.5L155 390c-20.6 2.6-39.3 6.1-55.4 10.2-56.6 14.6-56.6 32.9 0 47.5 39.9 10.3 95.8 16.2 156.4 16.2s116.5-5.9 156.4-16.2c56.6-14.6 56.6-32.9 0-47.5z" />
                          </svg>
                      </button>
                      <button
                          title="${strings.map25[LANGUAGE]}"
                          onclick="heartbank.alertAdmin('map/temple/click/study');alert('${strings
                              .soon[LANGUAGE]}')"
                          type="button"
                          class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border-t border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                          <svg
                              class="w-5 h-5 me-0"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="orange"
                              viewBox="0 0 576 512">
                              <path
                                  d="M302.3-12.6c-9-4.5-19.6-4.5-28.6 0l-256 128C1.9 123.3-4.5 142.5 3.4 158.3s27.1 22.2 42.9 14.3L288 51.8 529.7 172.6c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9l-256-128zM288 272a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm0 48c-53 0-96 43-96 96l0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32c0-53-43-96-96-96zM160 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm352 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM112 336c-44.2 0-80 35.8-80 80l0 33.1c0 17 13.8 30.9 30.9 30.9l87.8 0c-4.3-9.8-6.7-20.6-6.7-32l0-48c0-18.4 3.5-36 9.8-52.2-12.2-7.5-26.5-11.8-41.8-11.8zM425.4 480l87.8 0c17 0 30.9-13.8 30.9-30.9l0-33.1c0-44.2-35.8-80-80-80-15.3 0-29.6 4.3-41.8 11.8 6.3 16.2 9.8 33.8 9.8 52.2l0 48c0 11.4-2.4 22.2-6.7 32z" />
                          </svg>
                      </button>
                      <button
                          title="${strings.map26[LANGUAGE]}"
                          onclick="heartbank.alertAdmin('map/temple/click/thank');alert('${strings
                              .soon[LANGUAGE]}')"
                          type="button"
                          class="inline-flex items-center px-3 py-1 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                          <svg
                              class="w-6 h-6 me-1 mt-1"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="orangered"
                              viewBox="0 0 24 24">
                              <path
                                  d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                  transform="rotate(45 12 12)" />
                          </svg>
                      </button>
                  </div>
                  <br />
                  <br />
                  <button
                      title="${strings.map45[LANGUAGE]}"
                      class="text-base"
                      onclick="window.open('${mapURL}', '_blank');heartbank.alertAdmin('map/click/temple/${temple.name}: ${mapURL}')">
                      ${strings.map21[LANGUAGE]}
                      <strong class="font-black text-orange-400">
                          ${getRandomNumber(1000, 10000, LANGUAGE)}
                      </strong>
                      <span>🗺️</span>
                  </button>
                  <br />
                  <br />
                  <button
                      title="${strings.map48b[LANGUAGE]}"
                      onclick="this.style.opacity=0.1;window.editTemplePhoto('${temple.id}')">
                      <img
                          src="${photo}"
                          alt="${temple.name}"
                          class="${isApple
                              ? ""
                              : "pr-5"} w-full object-cover rounded-lg" />
                      <br />
                  </button>
                  <br />
                  <button
                      title="${strings.map47b[LANGUAGE]}"
                      class="underline text-sm text-blue-600"
                      onclick="window.editTempleAddress('${temple.id}', '${temple.address}')">
                      ${temple.address || "Unknown Address"}
                      <span>✏️</span>
                  </button>
                  <br />
                  <button
                      onclick="${temple.status === "active"
                          ? `window.unpublishTemple('${temple.id}')`
                          : `window.publishTemple('${temple.id}')`}"
                      class="text-2xl mt-5 text-green-500">
                      ${temple.status === "active" ? "🌐" : "🌐"}
                      ${temple.status === "active"
                          ? strings.map50b[LANGUAGE]
                          : strings.map49b[LANGUAGE]}
                  </button>
                  <button
                      onclick="window.removeTemple('${temple.id}', '${temple.pid}')"
                      class="text-2xl mt-5 text-red-600">
                      🗑️ ${strings.map51b[LANGUAGE]}
                  </button>
              </div>`
            : html`<div class="max-w-[300] text-black dark:text-white pb-3">
                  <aside
                      class="absolute top-2 font-black text-xl text-purple-600 dark:text-purple-500">
                      ${strings.map27[LANGUAGE]}
                      <span class="text-teal-300">
                          ${getRandomNumber(1, 100, LANGUAGE)}
                      </span>
                  </aside>
                  <p class="font-bold text-2xl">${temple.name}</p>
                  <br />
                  <div class="inline-flex rounded-md shadow-xs" role="group">
                      <button
                          title="${strings.map6[LANGUAGE]}"
                          onclick="heartbank.alertAdmin('map/temple/click/333');alert('${strings
                              .soon[LANGUAGE]}')"
                          type="button"
                          class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                          <svg
                              class="w-5 h-5 me-0"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="gold"
                              viewBox="0 0 576 512">
                              <path
                                  d="M64 64C28.7 64 0 92.7 0 128L0 336c0 35.3 28.7 64 64 64l.4 0c4 44.9 41.7 80 87.6 80s83.6-35.1 87.6-80l104.7 0c4 44.9 41.7 80 87.6 80 46.1 0 83.9-35.4 87.7-80.5 31.7-3.8 56.3-30.8 56.3-63.5l0-101.3c0-13.8-4.5-27.3-12.8-38.4l-80-106.7C471.1 73.5 452.1 64 432 64L64 64zM504 224l-120 0 0-96 48 0 72 96zM64 224l0-96 96 0 0 96-96 0zm160 0l0-96 96 0 0 96-96 0zM392 392a40 40 0 1 1 80 0 40 40 0 1 1 -80 0zM152 352a40 40 0 1 1 0 80 40 40 0 1 1 0-80z" />
                          </svg>
                      </button>
                      <button
                          title="${strings.map24[LANGUAGE]}"
                          onclick="heartbank.alertAdmin('map/temple/click/checkin');alert('${strings
                              .soon[LANGUAGE]}')"
                          type="button"
                          class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border-t border-r border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                          <svg
                              class="w-5 h-5 me-0"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="blueviolet"
                              viewBox="0 0 512 512">
                              <path
                                  d="M256 0a64 64 0 1 1 0 128 64 64 0 1 1 0-128zM224 160l64 0c35.3 0 64 28.7 64 64l0 48c0 17.7-14.3 32-32 32l-1.8 0-11.1 99.5c-1.8 16.2-15.5 28.5-31.8 28.5l-38.7 0c-16.3 0-30-12.3-31.8-28.5l-11.1-99.5-1.8 0c-17.7 0-32-14.3-32-32l0-48c0-35.3 28.7-64 64-64zM412.4 400.2c-16.1-4.2-34.8-7.6-55.4-10.2l5.3-47.7c22.7 2.9 43.7 6.7 62.1 11.5 22.4 5.8 42.6 13.3 57.8 23.3 14.7 9.6 29.8 24.9 29.8 47s-15.1 37.4-29.8 47c-15.2 9.9-35.5 17.5-57.8 23.3-45.1 11.7-105.3 17.8-168.4 17.8s-123.3-6.1-168.4-17.8C65.2 488.4 45 480.9 29.8 471 15.1 461.4 0 446.1 0 424s15.1-37.4 29.8-47c15.2-9.9 35.5-17.5 57.8-23.3 18.5-4.8 39.5-8.6 62.1-11.5L155 390c-20.6 2.6-39.3 6.1-55.4 10.2-56.6 14.6-56.6 32.9 0 47.5 39.9 10.3 95.8 16.2 156.4 16.2s116.5-5.9 156.4-16.2c56.6-14.6 56.6-32.9 0-47.5z" />
                          </svg>
                      </button>
                      <button
                          title="${strings.map25[LANGUAGE]}"
                          onclick="heartbank.alertAdmin('map/temple/click/study');alert('${strings
                              .soon[LANGUAGE]}')"
                          type="button"
                          class="inline-flex items-center px-4 py-2 text-sm font-medium text-gray-900 bg-white border-t border-b border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                          <svg
                              class="w-5 h-5 me-0"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="orange"
                              viewBox="0 0 576 512">
                              <path
                                  d="M302.3-12.6c-9-4.5-19.6-4.5-28.6 0l-256 128C1.9 123.3-4.5 142.5 3.4 158.3s27.1 22.2 42.9 14.3L288 51.8 529.7 172.6c15.8 7.9 35 1.5 42.9-14.3s1.5-35-14.3-42.9l-256-128zM288 272a56 56 0 1 0 0-112 56 56 0 1 0 0 112zm0 48c-53 0-96 43-96 96l0 32c0 17.7 14.3 32 32 32l128 0c17.7 0 32-14.3 32-32l0-32c0-53-43-96-96-96zM160 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm352 0a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zM112 336c-44.2 0-80 35.8-80 80l0 33.1c0 17 13.8 30.9 30.9 30.9l87.8 0c-4.3-9.8-6.7-20.6-6.7-32l0-48c0-18.4 3.5-36 9.8-52.2-12.2-7.5-26.5-11.8-41.8-11.8zM425.4 480l87.8 0c17 0 30.9-13.8 30.9-30.9l0-33.1c0-44.2-35.8-80-80-80-15.3 0-29.6 4.3-41.8 11.8 6.3 16.2 9.8 33.8 9.8 52.2l0 48c0 11.4-2.4 22.2-6.7 32z" />
                          </svg>
                      </button>
                      <button
                          title="${strings.map26[LANGUAGE]}"
                          onclick="heartbank.alertAdmin('map/temple/click/thank');alert('${strings
                              .soon[LANGUAGE]}')"
                          type="button"
                          class="inline-flex items-center px-3 py-1 text-sm font-medium text-gray-900 bg-white border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-0 focus:ring-blue-700 focus:text-blue-700 dark:bg-gray-800 dark:border-gray-700 dark:text-white dark:hover:text-white dark:hover:bg-gray-700 dark:focus:ring-blue-500 dark:focus:text-white">
                          <svg
                              class="w-6 h-6 me-1 mt-1"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="orangered"
                              viewBox="0 0 24 24">
                              <path
                                  d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
                                  transform="rotate(45 12 12)" />
                          </svg>
                      </button>
                  </div>
                  <br />
                  <br />
                  <p class="text-base">
                      ${strings.map21[LANGUAGE]}
                      <strong class="font-black text-orange-400">
                          ${getRandomNumber(1000, 10000, LANGUAGE)}
                      </strong>
                  </p>
                  <br />
                  <a
                      title="${strings.map45[LANGUAGE]}"
                      href="${mapURL}"
                      target="_blank"
                      onclick="heartbank.alertAdmin('map/click/temple/${temple.name}: ${mapURL}')">
                      <img
                          src="${photo}"
                          alt="${temple.name}"
                          class="${isApple
                              ? ""
                              : "pr-5"} w-full object-cover rounded-lg" />
                      <br />
                      <p
                          title="${strings.map45[LANGUAGE]}"
                          class="underline text-sm text-blue-600">
                          ${temple.address || "Unknown Address"}
                      </p>
                  </a>
              </div>`;

        if (reload) {
            this.infoWindow!.setContent(content);
        } else {
            const pin = new google.maps.marker.PinElement({
                background:
                    temple.status === "init"
                        ? "orange"
                        : temple.status === "active"
                        ? "orangered"
                        : "silver",
                borderColor: "red",
                glyph: "☸",
                glyphColor: "white",
                scale: this.templeSize
            });

            const position: google.maps.LatLngLiteral = {
                lat: temple.latitude,
                lng: temple.longitude
            };

            const marker = new google.maps.marker.AdvancedMarkerElement({
                map: this.map,
                position,
                content: pin.element,
                title: `${temple.name} | ${temple.address}`
            });

            marker.addListener("gmp-click", async () => {
                this.zoom();
                //this.bounds.extend(marker.position);

                this.readers.isRealTime = false;
                this.isInfoWindowOpen = true;
                this.infoWindow!.setContent(content);
                this.infoWindow!.open(this.map, marker);
                //infoWindow.open(this.map, marker);

                this.heartbank.alertAdmin(
                    `map/click/temple/${temple.name}: `,
                    temple.address
                );
            });

            this.templeMarkers.push(marker);
        }
    }

    private showTempleMarkers() {
        this.templeMarkers.forEach((marker) => (marker.map = this.map));
    }

    private hideTempleMarkers() {
        this.templeMarkers.forEach((marker) => (marker.map = null));
    }

    /**
     * Returns a normalized center point of the given Google Map.
     * Ensures latitude ∈ [-90, 90] and longitude ∈ [-180, 180].
     */
    private getNormalizedCenter(center: google.maps.LatLng): {
        lat: number;
        lng: number;
    } {
        //if (!center) throw new Error("Map center is undefined");

        const rawLat = center.lat();
        const rawLng = center.lng();

        // Clamp latitude to [-90, 90]
        const lat = Math.max(-90, Math.min(90, rawLat));

        // Wrap longitude to [-180, 180]
        const lng = ((((rawLng + 180) % 360) + 360) % 360) - 180;

        return { lat, lng };
    }

    /**
     * Calculates the radius of the current map view in meters, capped at the API's maximum.
     * @param bounds The current LatLngBounds of the map.
     * @returns The radius in meters, never exceeding 50000.
     */
    private calculateMapRadius(bounds: google.maps.LatLngBounds): number {
        // const center = bounds.getCenter();
        // const northEast = bounds.getNorthEast();
        // const distance = google.maps.geometry.spherical.computeDistanceBetween(
        //     center,
        //     northEast
        // );
        // return Math.min(distance, 50000); // Cap the radius to the API's maximum

        return 50000; // about 30 miles
    }

    // deprecated: old places api
    /**
     * Creates a single marker on the map for a given place.
     * @param place - The Google PlaceResult object for the temple.
     */
    private addTemple2(place: google.maps.places.PlaceResult) {
        if (!place.geometry?.location || !this.map) return;

        const pin = new google.maps.marker.PinElement({
            background: "orangered",
            borderColor: "#A0522D",
            glyph: "☸", // Dharma wheel symbol
            glyphColor: "white",
            scale: 1.5
        });

        const marker = new google.maps.marker.AdvancedMarkerElement({
            map: this.map,
            position: place.geometry.location,
            content: pin.element,
            title: place.name
        });

        const infoWindow = new google.maps.InfoWindow({
            content: `<div class="font-bold text-lg">${place.name}</div><p class="text-sm">${place.vicinity}</p>`
        });

        marker.addListener("gmp-click", () => {
            this.bounds.extend(marker.position);
            this.isInfoWindowOpen = true;
            infoWindow.open(this.map, marker);
        });

        this.templeMarkers.push(marker);
    }

    // helpers

    private zoom() {
        //this.map!.panTo(position);
        const level = this.map!.getZoom()!;
        if (level > 4 && level < 8) this.map!.setZoom(8); // does not animate // smaller zoom level = more zoomed out
    }

    private extendBounds(reader: Reader) {
        const position = {
            lat: reader.latitude,
            lng: reader.longitude
        };

        const isInCambodia =
            position.lat < this.cambodiaBounds.maxLat &&
            position.lat > this.cambodiaBounds.minLat &&
            position.lng < this.cambodiaBounds.maxLng &&
            position.lng > this.cambodiaBounds.minLng;

        //TODO: later when have more readers
        // if (LANGUAGE === "khmer") {
        //     if (isInCambodia) this.bounds.extend(position);
        // } else this.bounds.extend(position);

        this.bounds.extend(position);
    }

    public panToUser() {
        this.bounds.extend(this.location);
        this.map!.panTo(this.location!);
        if (this.map!.getZoom()! < 8) this.map!.setZoom(12);
        google.maps.event.trigger(this.marker!, "gmp-click");
    }

    private panToHome() {
        this.map!.panTo(LANGUAGE === "khmer" ? this.phnomPenh : this.USA);
        this.map!.setZoom(LANGUAGE === "khmer" ? 6.5 : 3.0);
    }

    // not used
    private animateToMarker(position: google.maps.LatLngLiteral) {
        // Smooth pan to the marker position
        //this.map!.panTo(position);

        // Animate zoom to target level (12)
        const targetZoom = 12;
        const currentZoom = this.map!.getZoom()!;
        const steps = 20; // Number of animation steps
        const zoomStep = (targetZoom - currentZoom) / steps;
        let step = 0;

        const animateZoom = () => {
            if (step < steps) {
                const newZoom = currentZoom + zoomStep * step;
                this.map!.setZoom(newZoom);
                step++;
                requestAnimationFrame(animateZoom);
            } else {
                this.map!.setZoom(targetZoom); // Ensure final zoom is exact
            }
        };

        animateZoom(); // Start zoom animation
    }

    private showMarkers() {
        if (this.showTemples) this.showTempleMarkers();
        if (this.showMonks)
            this.monkMarkers.forEach((marker) => (marker.map = this.map));
        if (this.showHomes)
            this.homeMarkers.forEach((marker) => (marker.map = this.map));
        if (this.showReaders)
            this.readerMarkers.forEach((marker) => (marker.map = this.map));
        this.watchCurrentPosition();
    }

    private hideMarkers() {
        // this.hideTempleMarkers();
        // this.monkMarkers.forEach((marker) => (marker.map = null));
        // this.homeMarkers.forEach((marker) => (marker.map = null));
        // this.readerMarkers.forEach((marker) => (marker.map = null));
        if (this.watchId) navigator.geolocation.clearWatch(this.watchId);
    }

    //// geolocation

    // initial location is IP then accurate
    public async getLocation(): Promise<FormattedLocation | null> {
        if (isProduction) {
            if (!this.loader) await this.initMap();
            await this.getCurrentLocation();
            if (!this.location) return null;

            const location = await this.geocode(this.location);
            if (location)
                localStorage.setItem("location", JSON.stringify(location));
            return location;
        } else return null;
    }

    // debounce not needed; just cache is enough
    private async geocode(
        coordinate: google.maps.LatLngLiteral
    ): Promise<FormattedLocation | null> {
        const gridSizeDegrees = 0.0144 * this.addressMiles; // 5 miles
        const gridLat =
            Math.round(coordinate.lat / gridSizeDegrees) * gridSizeDegrees;
        const gridLng =
            Math.round(coordinate.lng / gridSizeDegrees) * gridSizeDegrees;
        const cacheKey = `grid_${gridLat.toFixed(4)}_${gridLng.toFixed(4)}`;

        if (this.addressCache.has(cacheKey)) {
            const cachedLocation = this.addressCache.get(
                cacheKey
            ) as FormattedLocation;
            cachedLocation.lat = coordinate.lat;
            cachedLocation.lng = coordinate.lng;
            console.log("Using cached location address...", cachedLocation);
            return cachedLocation;
        }

        if (!(await this.quotas.isFree("geocoding"))) {
            // dummy location
            const location: FormattedLocation = {
                place_id: "0",
                formatted_address: "USA",
                lat: coordinate.lat,
                lng: coordinate.lng
            };
            return isProduction ? null : location;
        }

        try {
            const geocoder = new google.maps.Geocoder();
            const request: google.maps.GeocoderRequest = {
                location: coordinate,
                language: strings.language[LANGUAGE]
            };
            const response = await geocoder.geocode(request);

            if (response.results && response.results.length > 0) {
                // Use the first, most specific result
                const result = response.results[0];
                //console.log(result);

                const location: FormattedLocation = {
                    place_id: result.place_id,
                    formatted_address: result.formatted_address,
                    lat: coordinate.lat, //result.geometry.location.lat(),
                    lng: coordinate.lng //result.geometry.location.lng()
                };

                this.addressCache.set(cacheKey, location);
                return location;
            } else {
                console.warn(
                    "Geocoding failed: No results found for the location.",
                    coordinate
                );
                return null;
            }
        } catch (error) {
            console.error("Geocoding API call failed:", error);
            return null;
        }
    }

    // not used
    private async searchLocation2(): Promise<{
        city: string;
        country: string;
    } | null> {
        // 1. Check if location data is available
        if (!this.location) {
            console.error("Current location is not available to geocode.");
            return null;
        }

        // 2. Ensure Google Maps API and the Geocoder are loaded
        if (typeof google === "undefined" || !google.maps?.Geocoder) {
            console.error("Google Maps API or Geocoder not loaded.");
            return null;
        }

        const geocoder = new google.maps.Geocoder();
        const request: google.maps.GeocoderRequest = {
            location: this.location,
            language: strings.language[LANGUAGE]
        };

        try {
            const response = await geocoder.geocode(request);

            if (response.results && response.results.length > 0) {
                // Use the first, most specific result
                const result = response.results[0];
                let city: string | null = null;
                let country: string | null = null;
                //console.log(result);

                // Iterate through the address components to find the city and country
                for (const component of result.address_components) {
                    if (component.types.includes("locality")) {
                        city = component.long_name;
                    }
                    if (component.types.includes("country")) {
                        country = component.long_name;
                    }
                }

                // If city is still not found, check other administrative levels as a fallback
                if (!city) {
                    const adminArea = result.address_components.find((c) =>
                        c.types.includes("administrative_area_level_1")
                    );
                    if (adminArea) city = adminArea.long_name;
                }

                if (city && country) {
                    return { city, country };
                } else {
                    console.warn(
                        "Could not find city or country in geocoding response.",
                        result
                    );
                    return null;
                }
            } else {
                console.warn(
                    "Geocoding failed: No results found for the location.",
                    this.location
                );
                return null;
            }
        } catch (error) {
            console.error("Geocoding API call failed:", error);
            return null;
        }
    }

    private async getCurrentLocation() {
        if ("geolocation" in navigator) {
            const geolocation = await navigator.permissions.query({
                name: "geolocation"
            });
            this.handleGeolocation(geolocation);
            geolocation.onchange = () => this.handleGeolocation(geolocation); // does not work on ios
        } else {
            this.hideMarkers();
            if (window.location.hash === "#readership")
                alert(strings.map3[LANGUAGE]);
        }
    }

    // chrome
    private handleGeolocation(geolocation: PermissionStatus) {
        switch (geolocation.state) {
            case "prompt": // ios only here: TODO: fix confirm not asked prior to prompt
                if (
                    localStorage.getItem("isGranted") === "true" ||
                    this.isPrompted
                )
                    this.getCurrentPosition();
                else {
                    this.isPrompted = true;
                    this.isGranted = navigator.onLine
                        ? confirm(strings.map1[LANGUAGE])
                        : false;
                    if (this.isGranted) this.getCurrentPosition();
                    // else if (window.location.hash === "#readership")
                    //     window.location.hash = "#";
                }
                break;
            case "granted":
                if (
                    localStorage.getItem("isGranted") !== "true" &&
                    window.location.hash !== "#readership"
                )
                    window.location.hash = "#readership";
                localStorage.setItem("isGranted", "true");
                this.showMarkers();
                break;
            case "denied":
                localStorage.setItem("isGranted", "false");
                this.hideMarkers();
                // if (window.location.hash === "#readership")
                //     alert(strings.map2[LANGUAGE]); // weird bug: alert 2x
                break;
            default: // error?
                localStorage.setItem("isGranted", "false");
                this.hideMarkers();
        }
    }

    // safari
    private handleGeolocation2(isGranted: boolean) {
        if (isSafari) {
            if (isGranted) {
                if (
                    localStorage.getItem("isGranted") !== "true" &&
                    window.location.hash !== "#readership"
                ) {
                    window.location.hash = "#readership";
                }
                localStorage.setItem("isGranted", "true");
                this.showMarkers();
            } else {
                localStorage.setItem("isGranted", "false");
                this.hideMarkers();
                if (this.isGranted && !this.isPrompted2) {
                    this.isPrompted2 = true;
                    if (navigator.onLine) alert(strings.map2[LANGUAGE]);
                }
            }
        }
    }

    private getCurrentPosition() {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                this.location = {
                    lat: position.coords.latitude,
                    lng: position.coords.longitude
                };
                //this.map!.setCenter(this.location);
                //this.map!.setZoom(12);
                this.handleGeolocation2(true);
            },
            (error: any) => {
                this.handleGeolocation2(false);
                // if (error.code === error.PERMISSION_DENIED) {
                // } else {
                //     console.error("Geolocation error: ", error.message);
                // }
            }
        );
    }

    private watchCurrentPosition() {
        if (!this.watchId) {
            this.watchId = navigator.geolocation.watchPosition(
                (position) => {
                    //const { latitude, longitude } = position.coords;
                    this.location = {
                        lat: position.coords.latitude,
                        lng: position.coords.longitude
                    };
                },
                (error: any) => {
                    this.handleGeolocation2(false);
                    // if (error.code === error.PERMISSION_DENIED) {
                    // } else {
                    //     console.error("Error watching position: ", error.message);
                    // }
                },
                {
                    enableHighAccuracy: true, // optional: request high-accuracy if possible
                    maximumAge: 0, // optional: don't use cached position
                    timeout: Infinity // optional: no timeout
                }
            );
        }
    }

    // not used
    private debounce<T extends (...args: any[]) => any>(
        fn: T,
        delay: number
    ): (...args: Parameters<T>) => Promise<ReturnType<T>> {
        let timer: ReturnType<typeof setTimeout>;

        return (...args: Parameters<T>): Promise<ReturnType<T>> => {
            return new Promise((resolve) => {
                if (timer) clearTimeout(timer);

                timer = setTimeout(() => {
                    const result = fn(...args);
                    resolve(result);
                }, delay);
            });
        };
    }

    // deprecated
    private async renderReaders2() {
        // Cambodia
        for (let i = 0; i < this.size; i++) {
            const randomLat =
                Math.random() *
                    (this.cambodiaBounds2.maxLat -
                        this.cambodiaBounds2.minLat) +
                this.cambodiaBounds2.minLat;
            const randomLng =
                Math.random() *
                    (this.cambodiaBounds2.maxLng -
                        this.cambodiaBounds2.minLng) +
                this.cambodiaBounds2.minLng;
            const position = { lat: randomLat, lng: randomLng };

            const reader: Reader = {
                id: "",
                uid: "",
                user: "HeartBank®",
                address: strings.map17[LANGUAGE],
                latitude: position.lat,
                longitude: position.lng,
                lastActive: Timestamp.now(),
                pages: getRandomNumber2(100, 2000),
                rank: i + 1
            };

            // Extend bounds to include this marker's position
            if (LANGUAGE === "khmer") this.bounds.extend(position);
            this.addReader(reader, this.readerSize);
        }

        // USA
        for (let i = 0; i < this.size; i++) {
            const randomLat =
                Math.random() *
                    (this.californiaBounds2.maxLat -
                        this.californiaBounds2.minLat) +
                this.californiaBounds2.minLat;
            const randomLng =
                Math.random() *
                    (this.californiaBounds2.maxLng -
                        this.californiaBounds2.minLng) +
                this.californiaBounds2.minLng;
            const position = { lat: randomLat, lng: randomLng };

            const reader: Reader = {
                id: "",
                uid: "",
                user: "HeartBank®",
                address: strings.map17b[LANGUAGE],
                latitude: position.lat,
                longitude: position.lng,
                lastActive: Timestamp.now(),
                pages: getRandomNumber2(100, 1000),
                rank: i + 1
            };

            // Extend bounds to include this marker's position
            //if (window.innerWidth > 768) this.bounds.extend(position); // mobile device: You can adjust the breakpoint as needed
            if (LANGUAGE === "english") this.bounds.extend(position);
            this.addReader(reader, this.readerSize);
        }

        // France
        for (let i = 0; i < this.size; i++) {
            const randomLat =
                Math.random() *
                    (this.franceBounds.maxLat - this.franceBounds.minLat) +
                this.franceBounds.minLat;
            const randomLng =
                Math.random() *
                    (this.franceBounds.maxLng - this.franceBounds.minLng) +
                this.franceBounds.minLng;
            const position = { lat: randomLat, lng: randomLng };

            const reader: Reader = {
                id: "",
                uid: "",
                user: "HeartBank®",
                address: strings.map17c[LANGUAGE],
                latitude: position.lat,
                longitude: position.lng,
                lastActive: Timestamp.now(),
                pages: getRandomNumber2(100, 1000),
                rank: i + 1
            };

            // Extend bounds to include this marker's position
            //if (window.innerWidth > 768) this.bounds.extend(position); // mobile device: You can adjust the breakpoint as needed
            //this.bounds.extend(position);
            this.addReader(reader, this.readerSize);
        }

        // Australia
        for (let i = 0; i < this.size; i++) {
            const randomLat =
                Math.random() *
                    (this.australiaBounds.maxLat -
                        this.australiaBounds.minLat) +
                this.australiaBounds.minLat;
            const randomLng =
                Math.random() *
                    (this.australiaBounds.maxLng -
                        this.australiaBounds.minLng) +
                this.australiaBounds.minLng;
            const position = { lat: randomLat, lng: randomLng };

            const reader: Reader = {
                id: "",
                uid: "",
                user: "HeartBank®",
                address: strings.map17d[LANGUAGE],
                latitude: position.lat,
                longitude: position.lng,
                lastActive: Timestamp.now(),
                pages: getRandomNumber2(100, 1000),
                rank: i + 1
            };

            // Extend bounds to include this marker's position
            //if (window.innerWidth > 768) this.bounds.extend(position); // mobile device: You can adjust the breakpoint as needed
            //this.bounds.extend(position);
            this.addReader(reader, this.readerSize);
        }
    }
}
